const Settings = require('@transfeeradev/settings');
const UtilsService = require('./UtilsService');

class BtgAccountService {
  static async isIndirectAccount(branch, account) {
    const btgIndirectAccount = (await Settings.get(Settings.BTG)).indirect_account;

    return (
      UtilsService.removeLeadingZeros(UtilsService.getNumbersFromStr(btgIndirectAccount.agency)) ===
        UtilsService.removeLeadingZeros(UtilsService.getNumbersFromStr(branch)) &&
      UtilsService.removeLeadingZeros(UtilsService.getNumbersFromStr(btgIndirectAccount.number)) ===
        UtilsService.removeLeadingZeros(UtilsService.getNumbersFromStr(account))
    );
  }

  static async isMerchantAccount(branch, account) {
    const btgMerchantAccount = (await Settings.get(Settings.BTG)).account;

    return (
      UtilsService.removeLeadingZeros(UtilsService.getNumbersFromStr(btgMerchantAccount.agency)) ===
        UtilsService.removeLeadingZeros(UtilsService.getNumbersFromStr(branch)) &&
      UtilsService.removeLeadingZeros(UtilsService.getNumbersFromStr(btgMerchantAccount.number)) ===
        UtilsService.removeLeadingZeros(UtilsService.getNumbersFromStr(account))
    );
  }
}

module.exports = BtgAccountService;
